import { render } from "./AuthModals.vue?vue&type=template&id=18a48ec2&scoped=true&ts=true"
import script from "./AuthModals.vue?vue&type=script&lang=ts"
export * from "./AuthModals.vue?vue&type=script&lang=ts"

import "./AuthModals.vue?vue&type=style&index=0&id=18a48ec2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a48ec2"]])

export default __exports__